<div class="progress-wrapper">
  <div class="rating fs-22 mb-1 fw-600">
    {{ progress }}
  </div>
  <div class="progress-bar d-fex flex-row justify-content-start w-100">
    <span class="completed" [style.width.%]="progress * 25"></span>
  </div>
</div>
